import type { VariantProps } from 'class-variance-authority';

import { cva } from 'class-variance-authority';

export { default as HeroButton } from './Button.vue';

export const heroButtonVariants = cva(
	'flex h-10 items-center gap-2 px-4 py-2 lg:h-11',
	{
		variants: {
			variant: {
				default: '',
				// Removed transition-all to improve INP - instant state changes are better for performance
				transparent:
					'group border-none bg-black/40 text-white hover:bg-black focus:bg-black/60'
			}
		},
		defaultVariants: {
			variant: 'default'
		}
	}
);

export const heroButtonIconVariants = cva('', {
	variants: {
		variant: {
			default: '',
			// Removed transition-colors to improve INP
			transparent: 'text-white group-hover:text-beige'
		}
	},
	defaultVariants: {
		variant: 'default'
	}
});

export type HeroButtonVariants = VariantProps<typeof heroButtonVariants>;

export interface HeroButtonProps {
	variant?: HeroButtonVariants['variant'];
	class?: string;
}
